import { useState } from "react";
import { FaCheck, FaPenToSquare, FaQrcode, FaRightFromBracket, FaTrashCan, FaWhatsapp } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumber } from "../../../../../../utilities/formatNumber";
import { WaTableActionGroup } from "./components/action_button_group";
import { WaTableSkeleton } from "./components/skeleton";
import { WaTableEmptyState } from "./components/empty_state";
import { WaNumberStatusBadge } from "../../components/status_badge";
import { ScanModal } from "../modal/scan_modal";
import { WaNumberDeleteModal } from "../modal/delete_modal";
import { WaLogoutModal } from "../modal/logout_modal";
import { FaTimes } from "react-icons/fa";

export const WaDeviceTableSection = (
    {
        data, loading, refreshData,
        selectedDevice, setSelectedDevice,
        openUpdateDeviceModal, setOpenUpdateDeviceModal
    }
) => {
    const navigate = useNavigate();

    const [selectedIds, setSelectedIds] = useState([]);
    const [openScanModal, setOpenScanModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openLogoutModal, setOpenLogoutModal] = useState(false);

    const handleToggleSelect = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const handleSelectAll = () => {
        if (!data || data.length === 0) return;
        if (selectedIds.length === data.length) {
            setSelectedIds([]);
        } else {
            setSelectedIds(data.map((d) => d.id));
        }
    };


    const deviceColumns = [
        { key: "no", label: "No", align: "center", width: "50px" },
        { key: "primary", label: "Primary", },
        { key: "name", label: "Nama Perangkat", align: "left" },
        { key: "number", label: "Nomor WhatsApp", align: "left" },
        { key: "status", label: "Status", align: "center", },
        { key: "action", label: "Aksi", align: "center", },
    ];


    return (
        <>
            {/* ==================== DESKTOP TABLE ==================== */}
            <section
                className="hidden lg:block rounded-2xl overflow-hidden"
                style={{
                    background: "rgba(15, 23, 42, 0.4)",
                    border: "1px solid rgba(51, 65, 85, 0.3)",
                    backdropFilter: "blur(12px)",
                }}
                aria-label="Daftar Perangkat WhatsApp"
            >
                <div className="overflow-x-auto">
                    <table className="w-full text-sm">
                        <thead>
                            <tr
                                className="border-b"
                                style={{
                                    background: "rgba(15, 23, 42, 0.6)",
                                    borderColor: "rgba(51, 65, 85, 0.3)",
                                }}
                            >
                                <th className="px-4 py-3.5 text-center w-12">
                                    <input
                                        type="checkbox"
                                        checked={
                                            data?.length > 0 &&
                                            selectedIds.length === data.length
                                        }
                                        onChange={handleSelectAll}
                                        className="w-4 h-4 rounded border-slate-600 bg-slate-800 text-cyan-500 focus:ring-cyan-500/30 focus:ring-offset-0 cursor-pointer"
                                    />
                                </th>
                                {deviceColumns.map((col) => (
                                    <th
                                        key={col.key}
                                        className={`px-4 py-3.5 text-[10px] font-bold uppercase tracking-widest text-slate-500 ${col.align === "center"
                                            ? "text-center"
                                            : "text-left"
                                            }`}
                                        style={
                                            col.width
                                                ? { width: col.width }
                                                : undefined
                                        }
                                    >
                                        {col.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>

                        {loading ? (
                            <WaTableSkeleton />
                        ) : !data || data.length === 0 ? (
                            <tbody>
                                <tr>
                                    <td colSpan={deviceColumns.length + 1}>
                                        <WaTableEmptyState />
                                    </td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {data.map((item, index) => {
                                    const isConnected =
                                        item?.is_connected === true;
                                    return (
                                        <tr
                                            key={item.id}
                                            className="group transition-colors duration-150 border-b border-slate-800/30 last:border-0"
                                            style={{
                                                background: "transparent",
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.background =
                                                    "rgba(0, 180, 216, 0.03)";
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.background =
                                                    "transparent";
                                            }}
                                        >
                                            <td
                                                className="px-4 py-3.5 text-center"
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                            >
                                                <input
                                                    type="checkbox"
                                                    checked={selectedIds.includes(
                                                        item.id
                                                    )}
                                                    onChange={() =>
                                                        handleToggleSelect(
                                                            item.id
                                                        )
                                                    }
                                                    className="w-4 h-4 rounded border-slate-600 bg-slate-800 text-cyan-500 focus:ring-cyan-500/30 focus:ring-offset-0 cursor-pointer"
                                                />
                                            </td>

                                            <td className="px-4 py-3.5 text-center text-slate-600 font-mono text-xs">
                                                {index + 1}
                                            </td>

                                            <td className="px-4 py-3.5 text-center text-slate-600 font-mono text-xs flex items-center justify-center gap-1">
                                                {item?.primary ?
                                                    <FaCheck className="text-emerald-400 text-xs" />
                                                    : <FaTimes className="text-red-400 text-xs" />
                                                }
                                            </td>

                                            <td className="px-4 py-3.5">
                                                <div className="flex items-center gap-2.5">
                                                    <div
                                                        className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${isConnected
                                                            ? "bg-emerald-500/8 border border-emerald-500/15"
                                                            : "bg-slate-800/60 border border-slate-700/40"
                                                            }`}
                                                    >
                                                        <FaWhatsapp
                                                            className={`text-sm ${isConnected
                                                                ? "text-emerald-400"
                                                                : "text-slate-600"
                                                                }`}
                                                        />
                                                    </div>
                                                    <span className="font-semibold text-gray-100 text-sm">
                                                        {item?.name || "-"}
                                                    </span>
                                                </div>
                                            </td>

                                            <td className="px-4 py-3.5">
                                                <span className="font-mono text-sm text-slate-300">
                                                    {formatPhoneNumber(
                                                        item?.phone_number
                                                    )}
                                                </span>
                                            </td>

                                            <td className="px-4 py-3.5 text-center">
                                                <WaNumberStatusBadge
                                                    isActive={item?.is_active}
                                                />
                                            </td>

                                            <td
                                                className="px-3 py-3.5 text-center"
                                                onClick={(e) =>
                                                    e.stopPropagation()
                                                }
                                            >
                                                <WaTableActionGroup item={item}
                                                    handleOpenScan={() => {
                                                        setOpenScanModal(true);
                                                        setSelectedDevice(item);
                                                    }}
                                                    handleOpenUpdate={() => {
                                                        setOpenUpdateDeviceModal(true);
                                                        setSelectedDevice(item);
                                                    }}
                                                    handleOpenDelete={() => {
                                                        setOpenDeleteModal(true);
                                                        setSelectedDevice(item);
                                                    }}
                                                    handleOpenLogout={() => {
                                                        setOpenLogoutModal(true);
                                                        setSelectedDevice(item);
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        )}
                    </table>
                </div>
            </section>

            <ScanModal
                dataDevice={selectedDevice}
                openModal={openScanModal}
                setOpenModal={setOpenScanModal}
                refreshData={refreshData}
            />

            <WaNumberDeleteModal
                data={selectedDevice}
                openModal={openDeleteModal}
                setOpenModal={setOpenDeleteModal}
                refreshData={refreshData}
            />

            <WaLogoutModal
                dataDevice={selectedDevice}
                openModal={openLogoutModal}
                setOpenModal={setOpenLogoutModal}
                refreshData={refreshData}
            />
        </>
    )
}